import { Avatar, Button, Image, Tooltip } from "antd";
import { EditOutlined, CameraOutlined } from '@ant-design/icons';
import { UTC_LocalDateTime_relative } from "../../common/localDate";
import { Tags } from "../../common/tags";

const Card = ({ id, description, title, user, picture, modifiedat, inventory,instock,status, isEdit }) => {
    return (
        <div key={id} className="bg-white w-full rounded-xl shadow-sm p-4 flex gap-3 relative cursor-pointer  hover:bg-gray-200 hover:shadow" >
            <div>
                {picture !== null ?
                    <Image width={72} height={72} src={picture} style={{ borderRadius: 20 }} /> :
                    <Avatar size={72} shape='square' style={{ backgroundColor: 'whitesmoke' }} icon={<CameraOutlined style={{ color: 'silver' }} />} />
                }
            </div>

            <div className="flex-1" onClick={() => inventory(id)}>
                <div className="flex justify-between items-center mb-1 text-xs text-gray-400">
                    <span className="uppercase tracking-wide">
                        By {user} 
                    </span>
                    {isEdit ?
                        <Tooltip placement="top" title={'Edit'} >
                            <Button type="link" size='small' icon={<EditOutlined />} onClick={() => inventory(id)} >Edit</Button>
                        </Tooltip> :
                        <span>{UTC_LocalDateTime_relative(modifiedat, "MMM, DD YYYY - hh:mm A ")}</span>
                    }
                </div>
                <div className="flex justify-between items-center mb-1 ">
                    <h3 className="font-semibold text-gray-800">{title}</h3>
                    <span className="text-xs font-medium text-gray-600">In Stock : {instock}</span>
                   
                </div>


                <div className="flex justify-between items-center mt-2 text-xs text-gray-400">
                    <span>{description}</span>
                    {Tags(status)}
                </div>
            </div>
        </div>
    );
};
export default Card;